



const  ApiPath = "https://tom9.myexamo.com/tqwebsite";

//  const  ApiPath = "http://localhost:8080";

export default ApiPath;